(() => {
  const intro = document.querySelector('[data-solo-intro]');
  if (!intro) return;

  const seenKey = 'solo-store-intro-seen';
  const brand = intro.querySelector('.solo-store-intro__brand');
  const enterButton = intro.querySelector('[data-solo-intro-enter]');
  const hide = () => {
    intro.classList.add('is-hidden');
    window.setTimeout(() => intro.remove(), 700);
  };

  // The intro is shown only once for the whole browser session.
  // This prevents it from returning when the visitor opens another section or product.
  if (sessionStorage.getItem(seenKey) === '1') {
    hide();
    return;
  }

  // Mark the session immediately so page navigation cannot show the intro again.
  sessionStorage.setItem(seenKey, '1');

  // No timer: keep the intro visible until the visitor clicks the logo.
  const dismiss = () => hide();

  if (brand) {
    brand.setAttribute('role', 'button');
    brand.setAttribute('tabindex', '0');
    brand.setAttribute('aria-label', 'Enter Solo Store');
    brand.addEventListener('click', dismiss);
    brand.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        dismiss();
      }
    });
  }

  enterButton?.addEventListener('click', dismiss);
})();
